import { put, select, takeLatest } from 'redux-saga/effects'
import { IBloodProductAdministrationState } from '../store/bloodProductAdministration.types'
import { getBloodProductAdministrationSelector } from '../selectors/bloodProductAdministration.selector'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { BloodProductAdministrationConstants } from '../store/bloodProductAdministration.constants'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { throwPcrException } from '../../../pcr/store/pcr.actions'

export function* setDateTime() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const bloodProductAdministrationState: IBloodProductAdministrationState = yield select(
    getBloodProductAdministrationSelector
  )
  const { inputRows } = procedureState
  const {
    transfusionConsentDate,
    transfusionConsentTime,
    unitExpDate,
    unitExpTime,
    transfusionStartDate,
    transfusionStartTime,
    transfusionEndDate,
    transfusionEndTime,
  } = bloodProductAdministrationState
  try {
    inputRows.map((row) =>
      row.inputs.map((input) => {
        if (input.key === BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT_DATE_TIME) {
          //@ts-ignore
          input.props.time = transfusionConsentTime
          //@ts-ignore
          input.props.date = transfusionConsentDate
        } else if (input.key === BloodProductAdministrationConstants.SET_TRANSFUSION_START_DATE_TIME) {
          //@ts-ignore
          input.props.time = transfusionStartTime
          //@ts-ignore
          input.props.date = transfusionStartDate
        } else if (input.key === BloodProductAdministrationConstants.SET_TRANSFUSION_END_DATE_TIME) {
          //@ts-ignore
          input.props.time = transfusionEndTime
          //@ts-ignore
          input.props.date = transfusionEndDate
        } else if (input.key === BloodProductAdministrationConstants.SET_UNIT_EXPIRY_DATE_TIME) {
          //@ts-ignore
          input.props.time = unitExpTime
          //@ts-ignore
          input.props.date = unitExpDate
        }
      })
    )
    yield put(setInputRows(inputRows))
  } catch (e) {
    yield put(throwPcrException(`setDateTime() error: ${e}`))
  }
}

export function* setDateTimeSaga() {
  yield takeLatest(
    [
      BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT_DATE,
      BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT_TIME,
      BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT_DATE_TIME,
      BloodProductAdministrationConstants.SET_UNIT_EXPIRY_DATE,
      BloodProductAdministrationConstants.SET_UNIT_EXPIRY_TIME,
      BloodProductAdministrationConstants.SET_UNIT_EXPIRY_DATE_TIME,
      BloodProductAdministrationConstants.SET_TRANSFUSION_START_DATE,
      BloodProductAdministrationConstants.SET_TRANSFUSION_START_TIME,
      BloodProductAdministrationConstants.SET_TRANSFUSION_START_DATE_TIME,
      BloodProductAdministrationConstants.SET_TRANSFUSION_END_DATE,
      BloodProductAdministrationConstants.SET_TRANSFUSION_END_TIME,
      BloodProductAdministrationConstants.SET_TRANSFUSION_END_DATE_TIME,
    ],
    performWithMutexHOG,
    setDateTime
  )
}
